<script>
/**
 * PresentacionQuicktable
 * 
 * @author [authorName]
 * @date 6 de Agosto, 2024
 * @version 1.0
 */
import { captions, baseIndex as fetchingAPI } from './archetype.js'

import QuickCardFooter from '@/views/elements/quick-card-footer.vue'
import axios from 'axios'
import automodal from './autoform.vue'

let name = 'PresentacionQuicktable',
    newButtonLabel = 'New',
    emptyHeader = 'Data not found',
    emptyLead = 'Module empty',
    reloadData = 'Try reloading this page',
    tryAgainLater = '',
    header = null,
    footer = null;

export default {
    name,

    components: { automodal, QuickCardFooter },

    props: {
        disableNewModal: {
            type: Boolean,
            default: false
        },
        tipo: {
            type: [String, Number]
        },
        elementoId: {
            type: [String, Number]
        },
        fetchingAPI: {
            type: String,
            default: () => { return fetchingAPI }
        },
        header: {
            type: String,
            default: () => { return header }
        },
        perPage: {
            type: Number,
            default: 10,
        },
        footer: {
            type: String,
            default: () => { return footer }
        },
        captions: {
            type: [Array, Object],
            default: () => captions
        }
    },

    computed: {
        
        sourceURI() {
            let params = {
                tipo: this.tipo,
                elementoId: this.elementoId,
                sortBy: this.sorting.sortBy, 
                sortDesc: this.sorting.sortDesc
            },
                searchParams = new URLSearchParams(params),
                init = this.fetchingAPI + "/" + this.perPage + "/" + this.currentPage;

            if (!!this.term) {
                init += "/" + this.term;
            } else if (!this.term || this.term == "s") {
                init += "/@";
            }

            init += "/" + searchParams.toString().replaceAll(/\&/g, ':')

            return init;

        }
    },

    data: () => {
        return {
            name, newButtonLabel, emptyHeader,
            emptyLead, tryAgainLater, reloadData,
            currentPage: 1,
            items: [],
            itemsCount: 0,
            term: null,
            isLoading: false,
            sorting: {
				sortBy: null,
				sortDesc: null
			}
        }
    },

    methods: {
        sortChanged(e){
			this.sorting = e;
			this.loadUp()
		},
        async refreshFromStart() {
            this.currentPage = 1
            this.refresh()
        },
        async refresh() {
            this.isLoading = true
            await this.loadUp()
            this.isLoading = false
        },
        async loadUp() {
            try {
                let response = await axios.get(this.sourceURI)
                this.items = response.data.rows;
                this.itemsCount = response.data.count;
                this.loading = false;
            } catch (error) {
                console.error(error)
            }
        }
    },

    watch: {
        currentPage(a, b) {
            this.refresh();
        },
        '$route'() {
            this.loadUp()
        }
    },

    mounted() {
        this.refresh()
    }
};
</script>

<template>
    <div :id="name">

        <b-card no-body>

            <!-- TABLE CONTENT -->
            <b-table v-if="items.length && !isLoading" class="animated fadeIn" responsive :items="items" :fields="captions" @sort-changed="sortChanged">

                <!-- START TEMPLATES BASICOS DE DATOS -->
                <template #cell(imagen_uri)="data">
                    <div class="product-img">
                        <img v-if="!!data.value" :src="data.value" />
                        <img v-else src="https://api.supereasy.mx/storage/img/render/aab9ab5b8648335f07ad079381ff04a2/3" />
                    </div>
                    <!-- {{data.item.value}}  -->
                    <!-- {{data.item.titulo_extendido}}  -->
                </template>

                <template #cell(titulo_extendido)="data">
                    <div class="nowarp">
                        <span>{{ data.value }}</span>
                    </div>
                </template>
                <template #cell(marca)="data">
                    <div class="nowarp">
                        <span>{{ data.value }}</span>
                    </div>
                </template>
                <template #cell(presentacion)="data">
                    <div class="nowarp">
                        <span>{{ data.item.tipopresentacion }} {{ data.item.presentacion }} {{ data.item.unidadmedicion }}</span>
                    </div>
                </template>
                <template #cell(costo)="data">
                    <div class="nowarp">
                        <span>{{ data.item.costo | currency }}</span>
                    </div>
                </template>
                <template #cell(precio)="data">
                    <div class="text-center">
                        <div class="nowarp">
                            <span>{{ data.value | currency }}</span>
                        </div>
                        <small title="Precio restaurante">{{ data.item.precio_restaurante | currency }}</small>
                    </div>
                </template>
                <!-- END TEMPLATES BASICOS DE DATOS -->

                <!-- START OF AVATAR SAMPLES -->
                <template #cell(imagenes_id_agenda)="data">
                    <api-img :comp="data.value" :rowed="true" />
                </template>
                <!-- END OF AVATAR SAMPLES -->

                <!-- START OF BOOLEAN SAMPLE -->
                <template #cell(disponibilidad)="data">
                    <div class="align-center text-primary"
                        v-if="data.item.visible_en_tienda == '1' && data.item.visible_en_zero == '1'">
                        <i class="fa fa-eye"></i> Siempre
                    </div>
                    <div class="align-center text-warning"
                        v-else-if="data.item.visible_en_tienda == '1' && data.item.visible_en_zero == '0'">
                        <i class="fa fa-eye"></i> Solo con inventario
                    </div>
                    <div class="align-center text-danger" v-else-if="data.item.visible_en_tienda == '0'">
                        <i class="fa fa-eye-slash"></i> Oculto
                    </div>
                </template>
                <!-- END OF BOOLEAN SAMPLE -->

                <template #cell(_)="data" >
                    <!-- {{ data.item.presentacion_id_pk }} -->
                    <!-- [{{ tipo }}] -->
                    <automodal :concept-id="data.item.presentacion_id_pk" @refresh="refresh" :tipo="data.item.tipo">
                        Editar
                    </automodal>
                </template>

            </b-table>

            <!-- LOADING SPINNER -->

            <div v-if="isLoading">
                <div class="text-center p-5">
                    <b-spinner variant="primary" />
                </div>
            </div>

            <!-- EMPTY JUMBOTRON -->

            <div v-else-if="!items.length" class="pt-4 pl-4 pr-4 pb-0">
                <b-jumbotron :header="emptyHeader" :lead="emptyLead">
                    <p>{{ tryAgainLater }}</p>
                    <b-button variant="primary" @click="refresh()">{{ reloadData }}</b-button>
                </b-jumbotron>
            </div>

            <!-- HEADER -->

            <template v-slot:header>
                <b-row align-h="between">

                    <b-col md="auto" v-if="!!header">
                        <h6 class="mt-2 mb-2">{{ header }}</h6>
                    </b-col>

                    <b-col>
                        <b-input-group>
                            <b-form-input v-model="term" @keyup.enter="refreshFromStart()" placeholder="Buscador..." />
                            <b-input-group-append>
                                <b-button v-if="!!term" variant="secondary" @click="term = ''; refreshFromStart();"><i
                                        class="fa fa-times"></i></b-button>
                                <b-button variant="secondary" @click="refreshFromStart()" :disabled="!term"><i
                                        class="fa fa-search"></i></b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-col>

                    <b-col md="auto" class="align-right" v-if="!disableNewModal">
                        <automodal @refresh="refresh" :elemento-id="elementoId" :tipo="tipo">
                            Nuevo
                        </automodal>
                    </b-col>

                </b-row>
            </template>

            <!-- FOOTER -->

            <template v-slot:footer v-if="!isLoading && items.length">
                <quick-card-footer :items-count="itemsCount" :per-page="perPage" v-model="currentPage" @refresh="refresh"
                    :items-fetched="items.length" />
            </template>

        </b-card>

    </div>
</template>

<style lang="less">
#PresentacionQuicktable {
    @SIZE: 5em;

    .product-img {
        width: @SIZE;
        height: @SIZE;

        IMG {
            width: 100%;
            height: 100%;
            border-radius: .5em;
            object-fit: cover;
            border: 1px solid lightgray;
            // position: relative;
            // top: .75em;
        }
    }
}</style>